import { render } from "./SalesHistoricSearch.vue?vue&type=template&id=688157df&scoped=true"
import script from "./SalesHistoricSearch.vue?vue&type=script&lang=js"
export * from "./SalesHistoricSearch.vue?vue&type=script&lang=js"

import "./SalesHistoricSearch.vue?vue&type=style&index=0&id=688157df&lang=css"
import "./SalesHistoricSearch.vue?vue&type=style&index=1&id=688157df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688157df"]])

export default __exports__